import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectedDefaultChannel } from 'components/KBQSelect'

const initialState: SelectedDefaultChannel[] = []
const selectedDefaultChannelVisitedKBQOptionsSlices = createSlice({
  name: 'selectedDefaultChannelVisitedKBQOptions',
  initialState,
  reducers: {
    setSelectedDefaultChannelVisited(state, action: PayloadAction<SelectedDefaultChannel>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})

export const { setSelectedDefaultChannelVisited } =
  selectedDefaultChannelVisitedKBQOptionsSlices.actions

export default selectedDefaultChannelVisitedKBQOptionsSlices.reducer
